
document.addEventListener('DOMContentLoaded', function () {
  console.log('Script loaded and DOM fully parsed.');

  // Target only the first tab: .x-menu--level-1--container li:nth-child(1)
  const firstTab = document.querySelector('.x-menu--level-1--container li:nth-child(1)');
  if (!firstTab) {
    console.log('First menu tab not found.');
    return;
  }

  const menuContainer = firstTab.querySelector('.x-menu--level-2--container');
  if (!menuContainer) {
    console.log('Menu container not found inside first tab.');
    return;
  }

  const wrapper = menuContainer.querySelector('.x-menu--level-2--wrapper');
  const allULs = wrapper ? wrapper.querySelectorAll('ul') : [];

  console.log(`Found ${allULs.length} UL elements in first tab.`);

  const firstUL = allULs[0];
  const lastUL = allULs[allULs.length - 1];

  if (firstUL && lastUL && firstUL !== lastUL) {
    const itemToMove = firstUL.querySelector('li');
    if (itemToMove) {
      lastUL.appendChild(itemToMove);
      console.log('Moved "Nail Polish Collections & Kits" to the last UL.');
    } else {
      console.log('No list item found in the first UL to move.');
    }
  } else {
    console.log('Either first or last UL not found, or they are the same.');
  }

  // Apply flex layout only inside the scoped wrapper
  if (wrapper) {
    wrapper.style.display = 'flex';
    wrapper.style.flexWrap = 'wrap';
    wrapper.style.gap = '30px';
    console.log('Flex styles applied to first tab wrapper.');
  } else {
    console.log('Wrapper not found in first tab.');
  }
});

  function moveKlaviyoButton() {
    const notifyBtn = document.querySelector('.klaviyo-bis-trigger');
    const buyButtonsRoot = document.querySelector('product-buy-buttons-element.product-buy-buttons--root');
    const primaryBtn = buyButtonsRoot?.querySelector('.product-buy-buttons--primary');

    if (notifyBtn && buyButtonsRoot && primaryBtn && !buyButtonsRoot.contains(notifyBtn)) {
      primaryBtn.insertAdjacentElement('afterend', notifyBtn);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    moveKlaviyoButton();

    // MutationObserver to catch late-loaded Klaviyo button
    const observer = new MutationObserver(moveKlaviyoButton);
    observer.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const filterDrawer = document.querySelector('.filter--for-drawer');
    const drawerContainer = document.querySelector('.drawer--container[data-view="filter"]');

    if (filterDrawer && drawerContainer) {
      // Move the filter drawer content into the correct drawer view
      drawerContainer.appendChild(filterDrawer);

      // Ensure it's visible when the drawer opens
      filterDrawer.style.display = 'block';
    }
  });
/*
document.addEventListener("DOMContentLoaded", () => {
  // Create and insert loading overlay spinner
  const createLoadingOverlay = () => {
    if (document.querySelector(".variant-loading-overlay")) return;

    const overlay = document.createElement("div");
    overlay.className = "variant-loading-overlay";
    overlay.innerHTML = `<div class="spinner"></div>`;
    document.body.appendChild(overlay);
  };

  // Attach redirect behavior to variant inputs
  const attachVariantReloadListeners = () => {
    const inputs = document.querySelectorAll('[data-item="disclosure"], [data-item="radio"]');

    inputs.forEach((input) => {
      if (input.dataset.redirectListenerAttached === "true") return;

      input.addEventListener("change", (event) => {
        const url = event.target.getAttribute("data-product-url");

        if (url) {
          createLoadingOverlay();
          document.body.classList.add("variant-loading");

          setTimeout(() => {
            window.location.href = url;
          }, 300); // slight delay to show animation
        } else {
          console.warn("⚠️ No data-product-url on variant input:", event.target);
        }
      });

      input.dataset.redirectListenerAttached = "true";
    });
  };

  attachVariantReloadListeners();
  document.addEventListener("shopify:section:load", attachVariantReloadListeners);
});


*/




